// store.js
import { writable } from 'svelte/store';
import {Product, ShoppingCartProduct} from '../proto/products_pb';

import {load}  from 'protobufjs';

// Initialize the store with the current value in local storage
/**
 * @param {string} key - The key to use in local storage.
 * @param {ShoppingCartProduct[]} startValue - The initial value to use if the key is not found in local storage.
 * @returns {import('svelte/store').Writable<ShoppingCartProduct[]>}
 * */
const initializeStore = (key, startValue) => {
  const storedValueJson = localStorage.getItem(key);
  /**
   * @type {ShoppingCartProduct[]}
   * */
  let products = [];
  if (storedValueJson !== null) {
    /**
     * @type {ShoppingCartProduct.AsObject[]}
     * */
    const listOfProducts = JSON.parse(storedValueJson);
    console.log(listOfProducts);
    products = listOfProducts.map((product) => {
      const protoProduct = new ShoppingCartProduct();
      const newProd = new Product();
      console.log(product);
      /**
       * @type {Product.AsObject}
       * */
      const productObj = product.product;
      newProd.setId(productObj.id);
      newProd.setUrl(productObj.url);
      newProd.setName(productObj.name);
      newProd.setPrice(productObj.price);
      newProd.setCategory(productObj.category);
      newProd.setDiscountedprice(productObj.discountedprice);
      protoProduct.setProduct(newProd);
      protoProduct.setQuantity(product.quantity);
      return protoProduct;
    });
  } else {
    products = startValue;
  }
  const initialValue = products;

  /**
   * @type {import('svelte/store').Writable<ShoppingCartProduct[]>}
   * */
  const store = writable(initialValue, () => {
    const unsubscribe = store.subscribe(value => {
      // value is a list of products
      // update the localstorage with the json representation

      // copilot go
      const json = value.map((product) => {
        // convert product to json
        console.log(typeof product.getQuantity());
        return product.toObject();
      });
      console.log(json);


      console.log('Storing in local storage:', json);
      localStorage.setItem(key, JSON.stringify(json));
    });

    return unsubscribe;
  });

  return store;
};

let newItem = "";

/**
 * @type {import('svelte/store').Writable<ShoppingCartProduct[]>}
 */
export const items = initializeStore('shopping-list', []);
/**
 * @param {Product} item - The item to add to the list.
 */
export const addItem = (item) => {
  // check if exists, if yes, update with quantity + 1
  
  const currentItem = getItemById(item.getId());
  // if item exists, update quantity
  if (currentItem) {
    updateItem(item.getId(), currentItem.getQuantity() + 1);
    return;
  }

  const cartProduct = new ShoppingCartProduct();
  cartProduct.setProduct(item);
  cartProduct.setQuantity(1);
  items.update(n => [...n, cartProduct]);
  newItem = '';
};

/**
 * @param {string} id - The ID of the item to find.
 * @returns {ShoppingCartProduct | null}
 * */
const getItemById = (id) => {
  let currentItem = null;
  const unsubscribe = items.subscribe((items) => {
    currentItem = items.find(item => item.getProduct().getId() === id);
  });
  unsubscribe();
  return currentItem;
}

/**
 * @param {string} id - The ID of the item to remove from the list.
 * @returns {void}
 */
export const removeItem = (id) => {
  items.update(n => n.filter(item => item.getProduct().getId() !== id));
}

/**
 * @param {string} id - The ID of the item to update.
 * @param {number} newQuantity - The new quantity of the item.
 */
export const updateItem = (id, newQuantity) => {
 items.update(n => {
    const item = n.find(item => item.getProduct().getId() === id);
    if (item) {
      item.setQuantity(newQuantity);
    }
    return n;
  });
}
